import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { makeStyles } from '@material-ui/core/styles';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';

const useStyles = makeStyles({
 container: {
  display: 'flex',
  flexDirection: 'column',
  border: '1px green solid',
  overflow: 'auto',
  padding: '20px',
  marginLeft: '80px',
  marginRight: '80px',
  marginTop: '60px',
  width: 'calc(100% - 160px)',
  cursor: 'default',
  overflowX: 'auto',
  overflowY: 'auto',
  height: '100%',
 },
});

const Documents = () => {
 const classes = useStyles();

 return (
  <div>
   <Card className={classes.container}>
    <CardActionArea sx={{ cursor: 'default' }}>
     <CardContent>
      <Typography
       sx={{
        marginBottom: '20px',
        cursor: 'default',
        fontWeight: 800,
        color: '#FFB614',
       }}
      >
       Список документов
      </Typography>
      <Typography
       variant="body2"
       sx={{ color: 'text.secondary', cursor: 'default', marginBottom: '20px' }}
      >
       Нажмите на ссылку, чтобы скачать документ
       <br />
       <div
        style={{
         marginTop: '20px',
         fontWeight: 800,
         display: 'flex',
         flexDirection: 'column',
        }}
       >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../Приказ о внесении изменений  об утверждении форм заявлений потребителей 2025.docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           приказ о внесении изменений об утверждении форм заявлений
           потребителей 2025
          </label>
         </a>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../прил. 2 ф.12 заявление на заключение договора эс в отношении нп для фл.docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           прил. 2 ф.12 заявление на заключение договора эс в отношении нп для
           фл
          </label>
         </a>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../прил. 3 ф. 17 заявление на заключение договора эс для юл (1-6 цк).docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           прил. 3 ф. 17 заявление на заключение договора эс для юл (1-6 цк)
          </label>
         </a>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../прил. 4 ф. 42 форма предоставления сведений для договора ку.docx"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           прил. 4 ф. 42 форма предоставления сведений для договора ку
          </label>
         </a>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
         <a
          href="../../../прил. 5 ф. 43 договор-заявление для фл на заключение договор.doc"
          target="_blank"
         >
          <SimCardDownloadIcon sx={{ marginRight: '5px', color: '#FFB614' }} />
          <label
           style={{
            fontStyle: 'italic',
            cursor: 'pointer',
            paddingBottom: '20px',
            position: 'absolute',
           }}
          >
           прил. 5 ф. 43 договор-заявление для фл на заключение договор
          </label>
         </a>
        </div>
       </div>
      </Typography>
     </CardContent>
    </CardActionArea>
   </Card>
  </div>
 );
};

export default Documents;
